<template>
    <div class="home">
        <parts />
    </div>
</template>

<script>
    import Parts from "../components/views/Parts";
    export default {
        name: "PartsView",
        components: {Parts}
    }
</script>

<style scoped>

</style>
